import { TAB_MORE, UPDATE_MEMBER_LEAVE } from '../constants/actionTypes'
import ACTS from '../constants'

const defaultStatus = {
    title: '내 정보',
    tabId: 'more',
    adminInfo: {},
    disk: {},
    fieldReset : 'N',
    updateFieldNm: ''
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case TAB_MORE:
            return {
                ...state,
                tabId: action.tabId,
                active: action.active/*,
                subActive: action.active === 'move' ? 'my' : 'send'*/
            }
        case UPDATE_MEMBER_LEAVE:                         
            window.Alert.info("서비스를 이용해 주셔서 감사합니다.");
            return {
                ...state,
                completeLeave: true
            }
        case ACTS.ADMIN_INFO:                       
            return {
                    ...state,
                    adminInfo : action.payload.item.key
            }   
        case ACTS.GOOGLE_INFO:
            return {
                ...state,
                disk: (!action.payload.item || action.payload.item.disk === undefined) ? '' : action.payload.item.disk
            }
        case ACTS.UPDATE_MEMBER:             
            window.Alert.close()
            window.Alert.notify('변경되었습니다.');              
            return {    
                ...state,
                fieldReset : 'Y',
                updateFieldNm : action.field
            } 
        case ACTS.UPDATE_MEMBER_OK: 
            return {    
                ...state,
                fieldReset: 'N',
                updateFieldNm: ''
            }
        case ACTS.GET_TICKET_LAST: 
            return {
                ...state,
                ticketLast: (!action.payload.item || action.payload.item.info === undefined) ? '' : action.payload.item.info
            }
        case ACTS.UPDATE_COMPANY_SIMPLE: 
            return {
                ...state,
                completedCompanySimple: action.payload.result
            }
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/myInfo.js